export default __webpack_public_path__ + "static/media/prototype3.7d3db8d1.svg";